import { c as _c } from "react/compiler-runtime";
import { IcoFootprintShield16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type SecuredByFootprintProps = {
  className?: string;
};
const SecuredByFootprint = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] !== className) {
    t2 = cx("flex items-center justify-center gap-2", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoFootprintShield16 className="text-secondary" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="text-secondary text-caption-1">{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default SecuredByFootprint;
function _temp($) {
  return $["secured-by-footprint"];
}